import environment from "flow/configuration/environment";

/**
 * Utility to read server-rendered configuration from JSON script tag
 * This approach avoids the need for unsafe-inline in CSP
 */

interface IAppConfig {
    ecmaVersion: number;
    culture: string;
    uiCulture: string;
    version: string;
    domainId: string;
    productionMode: boolean;
    hasFooter: boolean;
    useCustomLogo: boolean;
}

let cachedConfig: IAppConfig | null = null;

/**
 * Gets the application configuration from the JSON script tag
 * @returns Application configuration object
 */
export function getAppConfig(): IAppConfig {
    if (cachedConfig) {
        return cachedConfig;
    }

    const configElement = document.getElementById("app-config");
    if (!configElement) {
        throw new Error("App configuration not found. Make sure the app-config script tag exists.");
    }

    try {
        cachedConfig = JSON.parse(configElement.textContent || "{}");
        return cachedConfig;
    } catch (error) {
        throw new Error("Failed to parse app configuration JSON: " + error);
    }
}

export function loadAppConfigIntoEnvironment() {
    const appConfig = getAppConfig();

    if (!appConfig) {
        throw new Error("App configuration not found.");
    }

    environment.set(environment.keys.culture, appConfig.culture);
    environment.set(environment.keys.uiCulture, appConfig.uiCulture);
    environment.set(environment.keys.version, appConfig.version);
}
